import * as core from '../../../../../../../core'
import * as prebuilt from '../../../../../../prebuilt'
import * as space from '../space'

export const RESOURCE = {
  payload: {
    alias: 'space:report',
    appAlias: space.RESOURCE.payload.alias,
    description: 'Single Report Details page',
    name: 'Report Details',
    page: { id: prebuilt.Page.Id.SpaceReport },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
